import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMA'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

// PDF individual: dados SÓ do QMA informado (sem merge, sem cadeia).
// Usado para qualquer clique de download em uma revisão específica (rev 0 solitária,
// rev 0 duplicada no expand, filhos rev 1/2/3).
const InformaoesPdfQmaIndividual = (data = {}, config = {}) =>
  APIClient.post(`${APIBusinessCommon}/${resourceName}/InformaoesPdfQmaIndividual`, data, config)

// PDF agrupado: construct virtual com pai + filhos da cadeia, atividades divididas por
// verificação, assinatura e metadado (via merge no front) do último. Usado apenas ao
// clicar na linha PRINCIPAL de um QMA que tem filhos (temFilhos=true).
const InformaoesPdfQmaAgrupado = (data = {}, config = {}) =>
  APIClient.post(`${APIBusinessCommon}/${resourceName}/InformaoesPdfQmaAgrupado`, data, config)

const GetCadeiaCorrecao = (qmaId, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${qmaId}/cadeia`, {}, config)

const inqueryQmaRepository = {
  InformaoesPdfQmaIndividual,
  InformaoesPdfQmaAgrupado,
  GetCadeiaCorrecao
}

export default inqueryQmaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmarepository.js